import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../common/components/Loader";
import { useDiscoveryMii } from "../DiscoveryMiiServiceProvider";
import { discoveryMiiFormatOptions, discoveryMiiPrompts } from "../defaults";

const DiscoveryMiiForm = (props) => {
    const [answer,setAnswer] = useState('');
    const navigate = useNavigate();
    const [ {getDiscoveryMiiJobDescriptionRequest}] = useDiscoveryMii()
    const [selectedOption, setSelectedOption] = useState(discoveryMiiFormatOptions[0].value);
    const [discoveryMiiJd, setDiscoveryMiiJd] = useState('');
    const [loading, setLoading] = useState(false);
    const maxLength = 1000

    const handleAnswerChange = (event) => {
        const newAnswers = event.target.value;
        setAnswer(newAnswers);
    };

    const handleJDSummary = (event) => {
        const newAnswer = event.target.value;
        setDiscoveryMiiJd(newAnswer);
    }

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    }

    const handleSubmitButtonClick = (event) => {
        event.preventDefault();
        const prompt = discoveryMiiPrompts.entryPrompt
        setLoading(true);
        getJobDescriptionRequest(prompt, answer, selectedOption)
    }

    const getJobDescriptionRequest = useCallback(async(prompt, answer, selectedOption) => {
        return await getDiscoveryMiiJobDescriptionRequest(prompt, answer, selectedOption)
        .then(request=>{
            if(!request?.error){
                setDiscoveryMiiJd(request?.description ? request?.description : request)
            }else{
                setLoading(false)
                setDiscoveryMiiJd("Something went wrong. Please try again!")
            }
            setLoading(false)
        })    
    }, [])

    return(
        <>
        {loading && <Loader/>}
        <div className={`flex flex-col justify-center items-center ${!discoveryMiiJd ? "h-full" : "h-[150%]"}  w-full space-y-2`}>
             <div className={`flex flex-row w-4/5 ${!discoveryMiiJd ? "h-2/4" : "h-2/4"}  bg-gray-200 p-4 rounded-lg shadow-md`}>
                <div className="flex-row w-4/5">
                    <textarea
                     className="w-full h-full p-2 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 6 resize-none"
                     id={`discovery-textarea`}
                     value={answer}
                     placeholder="Enter your description here"
                     onChange={handleAnswerChange}
                     maxLength={maxLength}
                    />
                </div>
                <div className="flex-row overflow-y-auto w-[20%]">
                    <div className="flex items-center justify-center">
                        <div className="container mx-auto px-4 py-8">
                            <h1 className="text-base font-bold mb-4">Select how the AI Assistant will respond:</h1>
                            <div className="flex flex-col gap-2">
                                {discoveryMiiFormatOptions.map((option) => (
                                <label key={option.id} className="inline-flex items-center">
                                    <input
                                    type="radio"
                                    className="form-radio"
                                    name="option"
                                    value={option.value}
                                    checked={selectedOption === option.value}
                                    onChange={handleOptionChange}
                                    />
                                    <span className="ml-2">{option.name}</span>
                                </label>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`flex flex-grow flex-row w-4/5 h-2/5 bg-gray-200 p-4 rounded-lg shadow-md display ${!discoveryMiiJd ? "hidden" : ""}`}>
                <div className="flex-grow">
                    {/* <PreformattedTextContainer 
                        props={discoveryMiiJd}
                        height='h-full'
                        width='w-full'
                    />     */}
                     <textarea
                     className="w-full h-full p-2 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 6 resize-none"
                     id={`discovery-textarea-jd`}
                     value={discoveryMiiJd}
                     placeholder="Enter your description here"
                     onChange={handleJDSummary}
                    //  maxLength={maxLength}
                    />                
                </div>
            </div>
            <div className="flex flex-row w-1/2 h-[5rem] bg-gray-200 p-4 rounded-lg shadow-md ">
                <div className="flex h-1/2 w-full justify-between">
                    <button className="h-12 bg-gray-500 hover:bg-gray-700 text-white-700 font-bold py-2 px-4 rounded" onClick={() => navigate("/Home")}>End Session</button>
                    <button 
                    onClick={(e) => {handleSubmitButtonClick(e)}}
                    // className="h-12 bg-indigo-500 hover:bg-indigo-700 text-white-700font-bold py-2 px-4 rounded-full mr-2"
                    className= "h-12 bg-blue-500 hover:bg-blue-700 text-white-700 font-bold py-2 px-4 rounded"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
        </>
    );
}

export default DiscoveryMiiForm